import { TrackingType } from "UidispatcherApiModule";
const { Tracking }: { Tracking: TrackingType } =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    await import("uidispatcher_api/UidispatcherApiModule");
export default Tracking;
